import { genomeOptions } from "../../constants";
import { initializeRecord } from "../../helpers/helpers";

const g = Object.keys(genomeOptions);

export const changeCalculatedPositions = (newValue) => {
    return {
        type: "calculatedPositions/calculatedPositionsUpdate",
        payload: newValue
    };
}

export const calculatedPositionsReducer = (state = initializeRecord(g, {}), action) => {
    switch(action.type) {
        case "calculatedPositions/calculatedPositionsUpdate":
            const { genome, positions } = action.payload;
            return {
                ...state,
                [genome]: positions
            };
        default:
            return state;
    };
}